export default __webpack_public_path__ + "static/media/check-mark.c0a0daef.svg";